import { createApp } from 'vue';
import InputSelect2 from './Components/Forms/InputSelect2';

require('./bootstrap');

createApp({
    data() {
        return {
        };
    },
    components: {
        InputSelect2,
    },
    mounted() {

    },
}).mount('#signup');
